import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AuthUser } from "@pkhoffice/shared";

type State = {
  accessToken: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  setTokens: (a: string, r: string, u: AuthUser) => void;
  clear: () => void;
};

export const useAuthStore = create<State>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      setTokens: (a, r, u) => set({ accessToken: a, refreshToken: r, user: u }),
      clear: () => set({ accessToken: null, refreshToken: null, user: null }),
    }),
    { name: "pkhoffice-auth" },
  ),
);
